import { Component, OnInit } from '@angular/core';
import { ShellUpdateService, ShellUpdateMessage, ShellActionMessage } from '../../services/shell-update-service/shell-update.service';
import { AppConfigService } from '../../services/app-config-service/app-config.service';
import { Router } from '@angular/router';
import { PatientDataService } from '../../services/patient-data/patient-data.service';
import { Patient } from '../../domain/patient';
import { LoggingService } from '../../services/logging-service/logging.service';
import { HttpErrorResponse } from '../../../../node_modules/@angular/common/http';
import { MatSnackBar } from '../../../../node_modules/@angular/material';
import { UserSessionService } from '../../services/user-session-service/user-session.service';
import { UsefulWebsite } from '../../models/useful-website';
import { TrustDataService } from '../../services/trust-data-service/trust-data.service';
import { pipe } from 'rxjs/util/pipe';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { Subscription } from 'rxjs';
import { SubscriptionLog } from 'rxjs/testing/SubscriptionLog';
import { HomeCardModel } from '../../models/home-card-model';
import { HomeCardService } from '../../services/home-card-service/home-card.service';


@Component({
  selector: 'app-mydetails-view',
  templateUrl: './portal-mydetails-view.component.html',
  styleUrls: ['./portal-mydetails-view.component.css']
})
export class PortalMyDetailsViewComponent implements OnInit {

  private patient: Patient;
  private previousAppointment: string;
  private documentLibrary: any;
  private usefulWebsites: UsefulWebsite[];
  loaded: boolean;
  error: boolean;
  cardSubscription: Subscription;
  aboutMe: HomeCardModel;

  constructor(private shellUpdateService: ShellUpdateService,
    private appConfigService: AppConfigService, private router: Router, private patientData: PatientDataService,
    private loggingService: LoggingService, private snackBar: MatSnackBar, private userSession: UserSessionService,
    private trustService: TrustDataService) { }

  ngOnInit() {
    this.loggingService.log('About Me >>>>>>>>>>>>>>>>>>>>', this.appConfigService.LogToConsole);

    // Make sure the route being accessed is desirable (not user from admin, or admin from user. Redirect if required)
    this.userSession.checkRoute(this.router.url);

    this.aboutMe = this.userSession.homeCards.find(x => x.CardName === 'AboutMe');

    this.shellUpdateService.sendShellUpdateMessage(new ShellUpdateMessage(
      this.appConfigService.ApplicationName, this.aboutMe.Title, null, null));


    this.shellUpdateService.sendShellUpdateActionMessage(new ShellActionMessage(false, false, true, true, true));

    // Get the patient for the view
    if (this.appConfigService.PatientId === undefined) {
      return;
    }

    // Get the required libraries and websites
    this.loggingService.log('Executing GetUsefulWebsites, GetLibrary', this.appConfigService.LogToConsole);
    forkJoin(this.trustService.getUsefulWebsites().pipe(map(response => response.json())),
      this.patientData.getLibrary().pipe(map(response => response.json()))
    )
      .subscribe(([usefulWebsites, documentLibrary]) => {
        this.loggingService.log('GetUsefulWebsites, GetLibrary succeeded', this.appConfigService.LogToConsole);
        this.usefulWebsites = usefulWebsites;
        this.documentLibrary = documentLibrary;
        console.log(documentLibrary);
      }, (error: HttpErrorResponse) => {
        this.loggingService.log('GetUsefulWebsites, GetLibrary failed', this.appConfigService.LogToConsole);
        this.handleError(error);
      });

    // Get the patient
    this.patientData.getPatient(this.appConfigService.PatientId).subscribe((response => {
      this.patient = response.json();
      this.loggingService.log('Executed getPatient', this.appConfigService.LogToConsole);

      // Split the NHS Number to appear as it should
      this.patient.NHSNumber = this.patient.NHSNumber.substring(0, 3) + ' ' +
        this.patient.NHSNumber.substring(3, 6) + ' ' + this.patient.NHSNumber.substring(6, 10);
      this.appConfigService.Forename = this.patient.Forenames;
      this.appConfigService.PatientInitials =
        this.patient.Forenames.substring(0, 1) + this.patient.Surname.substring(0, 1);

      // If no current pregnancy don't bother trying to get previous appointment
      if (this.patient.CurrentPregnancy === undefined || this.patient.CurrentPregnancy === null) {
        this.loaded = true;
        return;
      }

      // Get the previous appointment
      this.patientData.getPreviousAppointment(this.patient.CurrentPregnancy.PregnancyId).subscribe(result => {
        this.loggingService.log('Executed getPreviousAppointment', this.appConfigService.LogToConsole);
        this.previousAppointment = result.json();
        this.loaded = true;
      }, (error: HttpErrorResponse) => {
        this.handleError(error);
      });
    }), (error: HttpErrorResponse) => {
      this.handleError(error);
    });
  }

  handleError(error: HttpErrorResponse) {
    switch (error.status) {
      case 0:
        this.error = true;
        this.snackBar.open('Sorry, we can\'t do that. You appear to be offline.', '', { duration: 5000 });
        this.loggingService.log('Error - offline', this.appConfigService.LogToConsole);
        break;
      case 401:
        this.error = true;
        this.snackBar.open('Sorry, we can\'t do that. Your login has expired.', '', { duration: 5000 });
        this.loggingService.log('Error - login expired', this.appConfigService.LogToConsole);
        this.userSession.logout();
        break;
      case 500:
        this.error = true;
        this.snackBar.open('Sorry, we can\'t do that. Server error.', '', { duration: 5000 });
        this.loggingService.log('Error - Server error', this.appConfigService.LogToConsole);
      default:
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/portal-mydetails-view/portal-mydetails-view.component.ts